import graphql from "babel-plugin-relay/macro";

export const QUERY_FRAGMENT = graphql`
	fragment moduleRatingDetailsTable_RefetchableQueryFragment on Query
	@refetchable(queryName: "moduleRatingDetailsTable_Refetch")
	@argumentDefinitions(
		first: { type: "Int" }
		after: { type: "String" }
		nodeRef: { type: "ID!" }
		oneKeyId: { type: "String" }
	) {
		Admin {
			ModuleRating {
				ModuleRating(first: $first, after: $after, nodeRef: $nodeRef, oneKeyId: $oneKeyId)
					@connection(key: "moduleRatingsTable_ModuleRating") {
					edges {
						node {
							...moduleRatingDetailsTable_ModuleRatingInlineFragment
						}
					}
				}
			}
		}
	}
`;

export const MODULE_RATING_INLINE_FRAGMENT = graphql`
	fragment moduleRatingDetailsTable_ModuleRatingInlineFragment on ModuleRating @inline {
		node {
			id
			structureDefinition {
				title
			}
		}

		user {
			id
			name
		}
		value
		message
		oneKeyId
		createdAt
	}
`;

export const QUERY = graphql`
	query moduleRatingDetailsTable_Query($first: Int, $after: String, $nodeRef: ID!) {
		...moduleRatingDetailsTable_RefetchableQueryFragment
			@arguments(first: $first, after: $after, nodeRef: $nodeRef)
	}
`;
